import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import listQueryFilter from 'components/hoc/listQueryFilter';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import StatusField from 'components/field/StatusField';
import { fetchMembershipSchedules } from 'store/actions/membership-schedules/fetchMembershipSchedules';

const MembershipScheduleList = (props) => {
    const {
        actionType,
        location,
        resource,
        translate,
        updateQuery,
    } = props;

    return (
        <div>
            <ResourceList
                action={ fetchMembershipSchedules }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table
                    backgroundToggle={ {
                        condition: true,
                        color: theme.palette.chinook,
                        key: 'id',
                    } }
                >
                    <TextField
                        { ...props }
                        column={ {
                            sortable: false,
                            width: '20%',
                        } }
                        source='name'
                        label={ translate('filters.components.name.label') }
                    />

                    <StatusField
                        column={ {
                            align: 'center',
                            link: false,
                            sortable: false,
                            width: '10%',
                        } }
                        label='resources.products.fields.is_visible'
                        source='is_visible'
                    />
                </Table>
            </ResourceList>
        </div>
    );
};

MembershipScheduleList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

const enhance = compose(
    listQueryFilter,
    translate,
);

export default enhance(MembershipScheduleList);



// WEBPACK FOOTER //
// ./src/pages/membership-schedules/list/MembershipScheduleList.js